module.exports = __webpack_public_path__ + "static/media/img15.c62a1616.JPG";